/* unplugin-vue-components disabled */import script from "./BaseList.vue?vue&type=script&setup=true&name=BaseList&lang=js"
export * from "./BaseList.vue?vue&type=script&setup=true&name=BaseList&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=af034d30&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af034d30"]])

export default __exports__